import React, { useCallback, useEffect, useState } from "react";
import { connect } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { Form, Divider, Tabs, message, Input, Spin } from "antd";
import { ConfirmCancelButton, ConfirmButton } from "components/confirm";
import YmsFooterForm from "components/footerForm";
import Layout from "components/layout";
import { bindActionCreators } from "redux";
import { IDocumentType } from "store/lobby/lobby-model";
import { Creators as LocationActions } from "store/location/location-duck";
import { IProcessData, ILocation, IStructureData, IConfigurationActive, IConfigurationProcessActive } from "store/location/location-model";
import { Creators as UserSessionActions } from "store/user-session/user-session-duck";
import { IUserData, MenuItemActive } from "store/user-session/user-session-model";
import TokenService from "utils/auth/Token.service";
import { validateCreateUnit } from "utils/form/validations";
import useTranslation from "utils/hooks/useTranslation";
import ConfigurationTabPane from "./components/configurationTabPane";
import DataTabPanel from "./components/dataTabPane";
import DrawerConfiguration from "./components/DrawerConfig";
import DrawerProcessConfiguration from "./components/DrawerProcess";
import ProcessTabPanel from "./components/processTabPane";
import StructureTabPane from "./components/structureTabPane";
import { IProcessActive, onConfirmCreateUnit } from "./create-unit.service";
import * as S from "./styled/index.styled";

const { TabPane } = Tabs;

interface IPropsScreenLocationForm {
  isLoading?: boolean;
  isLoadingLocationEdit?: boolean;
  formViewOrEditModified?: boolean;
  userData?: IUserData;
  processList?: Array<IProcessData>;
  itemActive?: ILocation;
  processActive?: IProcessActive[];
  structureActive?: number;
  structuresList?: Array<IStructureData>;
  hasAttendanceActive?: boolean;
  expirationTimeActive?: number;
  checkinActive?: boolean;
  requestVehicleInboundActionActive?: boolean;
  requestDockEntryActionActive?: boolean;
  hasFinishOperationActionActive?: boolean;
  releaseVehicleActionActive?: boolean;
  vehicleArrivalConfirmActionActive?: boolean;
  hasReleaseWMSDocumentsActive?: boolean;
  hasLocationOutOfRangeActive?: boolean;
  hasCheckinScheduleActive?: boolean;
  hasEntryPermissionActive?: boolean;
  visibleDrawer?: boolean;
  visibleProcessDrawer?: boolean;
  documentTypeActive?: IDocumentType;
  configurationActive?: IConfigurationActive;
  configurationProcessActive?: IConfigurationProcessActive;
  originalProcessList?: IProcessData[];
  dropHookActive?: boolean;
  dropHookTypeActive?: number;
  hasRfidReadingActive?: boolean;
  plateFormatType?: number;
}
interface IDispatchProps {
  locationSaveAsync?: (...args) => void;
  locationsUpdateFormModified?: (...args) => void;
  locationsCreateActive?: (...args) => void;
  locationProcessesFetchAsync?: () => void;
  locationsFetchByIdAsync?: (...args) => void;
  locationsUpdateItemActive?: (...args) => void;
  locationsUpdateProcessActive?: (...args) => void;
  locationStructuresFetchAsync?: (...args) => void;
  locationsStructureActive?: (...args) => void;
  locationsCheckinActive?: (...args) => void;
  locationsHasAttendanceActive?: (...args) => void;
  locationsExpirationTimeActive?: (...args) => void;
  locationsAllowRequestVehicleInboundActionActive?: (...args) => void;
  locationsAllowRequestDockEntryActionActive?: (...args) => void;
  locationsHasFinishOperationActionActive?: (...args) => void;
  locationsReleaseVehicleActionActive?: (...args) => void;
  locationsCleanConfigurations?: () => void;
  locationsAllowVehicleArrivalConfirmActionActive?: (...args) => void;
  locationsHasReleaseWMSDocumentsActionActive?: (...args) => void;
  locationsHasLocationOutOfRangeActive?: (...args) => void;
  locationsHasCheckinScheduleActive?: (...args) => void;
  userSessionMenuItemActive?: (...args) => void;
  locationsConfigurationsUpdateFormFieldValue?: (...args) => void;
  locationsConfigurationsProcessUpdateFormFieldValue?: (...args) => void;
  locationsConfigurationsUpdateConfigurationActive?: (...args) => void;
  locationsConfigurationsUpdateConfigurationProcessActive?: (...args) => void;
  locationsDocumentNumberActive?: (...args) => void;
  locationsDropHookActive?: (...args) => void;
  locationsConfigurationsHideDrawer?: () => void;
  locationsConfigurationsShowDrawer?: () => void;
  locationsConfigurationsProcessHideDrawer?: () => void;
  locationsConfigurationsProcessShowDrawer?: () => void;
  locationsHasEntryPermissionActive?: (...args) => void;
  locationsHasRfidReadingActive?: (...args) => void;
  locationsPlateFormatActive?: (...args) => void;
}

export type IProps = IPropsScreenLocationForm & IDispatchProps;

type LayoutType = Parameters<typeof Form>[0]["layout"];

const LocationForm = ({
  isLoading,
  isLoadingLocationEdit,
  userData,
  formViewOrEditModified,
  processList,
  itemActive,
  processActive,
  structuresList,
  structureActive,
  hasAttendanceActive,
  expirationTimeActive,
  checkinActive,
  requestVehicleInboundActionActive,
  requestDockEntryActionActive,
  hasFinishOperationActionActive,
  releaseVehicleActionActive,
  vehicleArrivalConfirmActionActive,
  hasReleaseWMSDocumentsActive,
  documentTypeActive,
  hasLocationOutOfRangeActive,
  hasCheckinScheduleActive,
  visibleDrawer,
  visibleProcessDrawer,
  configurationActive,
  configurationProcessActive,
  originalProcessList,
  dropHookActive,
  dropHookTypeActive,
  hasEntryPermissionActive,
  hasRfidReadingActive,
  plateFormatType,
  locationSaveAsync,
  locationsUpdateFormModified,
  locationsCreateActive,
  locationsUpdateProcessActive,
  locationsUpdateItemActive,
  locationProcessesFetchAsync,
  locationsFetchByIdAsync,
  locationStructuresFetchAsync,
  locationsStructureActive,
  locationsCheckinActive,
  locationsHasAttendanceActive,
  locationsExpirationTimeActive,
  locationsAllowRequestVehicleInboundActionActive,
  locationsAllowRequestDockEntryActionActive,
  locationsHasFinishOperationActionActive,
  locationsReleaseVehicleActionActive,
  locationsCleanConfigurations,
  locationsAllowVehicleArrivalConfirmActionActive,
  locationsHasReleaseWMSDocumentsActionActive,
  locationsHasLocationOutOfRangeActive,
  locationsHasCheckinScheduleActive,
  userSessionMenuItemActive,
  locationsConfigurationsUpdateFormFieldValue,
  locationsConfigurationsProcessUpdateFormFieldValue,
  locationsConfigurationsShowDrawer,
  locationsConfigurationsHideDrawer,
  locationsConfigurationsProcessHideDrawer,
  locationsConfigurationsProcessShowDrawer,
  locationsConfigurationsUpdateConfigurationActive,
  locationsConfigurationsUpdateConfigurationProcessActive,
  locationsDocumentNumberActive,
  locationsDropHookActive,
  locationsHasEntryPermissionActive,
  locationsHasRfidReadingActive,
  locationsPlateFormatActive,
}: IProps) => {
  const tokenService = new TokenService();
  const router = useNavigate();
  const [form] = Form.useForm();
  const [checked, setChecked] = useState(false);
  const [formLayout, setFormLayout] = useState<LayoutType>("vertical");
  const DESCRIPTION_CANCEL = useTranslation({ id: "description_cancel" });
  const DESCRIPTION_CANCEL_EDIT = useTranslation({ id: "description_cancel_edit" });
  const YES_MESSAGE = useTranslation({ id: "yes" });
  const NO_MESSAGE = useTranslation({ id: "no" });
  const REQUIRED_FIELDS_MESSAGE = useTranslation({ id: "required_fields_are_required" });
  const TITLE_PAGE = useTranslation({ id: "location_registration" });
  const TITLE_PAGE_EDIT = useTranslation({ id: "unit_edition" });
  const PROCESS_REQUIRED_MESSAGE = useTranslation({ id: "process_required" });
  const MESSAGE_ACTIVATE_CHECKIN = useTranslation({ id: "message_activate_checkin" });
  const MANEUVER_PROCESS_REQUIRED_MESSAGE = useTranslation({ id: "maneuver_process_required" });
  const STRUCTURE_REQUIRED_MESSAGE = useTranslation({ id: "necessary_to_select_structure" });

  const { id } = useParams();
  const setMenuItemActive = () => userSessionMenuItemActive(MenuItemActive.UNITS);
  const processesFetchCallback = useCallback(() => locationProcessesFetchAsync(), []);
  const structuresFetchCallback = useCallback(() => locationStructuresFetchAsync(), []);
  const onFormLayoutChange = ({ layout }: { layout: LayoutType }) => {
    setFormLayout(layout);
  };

  const handleClose = () => {
    !formViewOrEditModified && locationsCreateActive(false);
    setMenuItemActive();
    router("/private/location");
  };

  useEffect(() => {
    processesFetchCallback();
    structuresFetchCallback();
  }, []);

  useEffect(() => {
    if (id) {
      userSessionMenuItemActive(MenuItemActive.LOCATION_EDIT);
      tokenService.authenticateToken();
      locationsFetchByIdAsync(id);
    }
  }, [id]);

  useEffect(() => {
    return () => {
      locationsUpdateItemActive(null);
      locationsUpdateFormModified(false);
      locationsUpdateProcessActive([]);
      locationsStructureActive(null);
      locationsCleanConfigurations();
    };
  }, []);

  useEffect(() => {
    if (itemActive?.id && structuresList?.length > 0) {
      const getRegionDataFromChild = (childId: number) => {
        const parent = structuresList.find((p) => p.childrens?.some((c) => c.id === childId));
        if (!parent) return null;

        return {
          parentId: parent.id,
          childId: childId,
        };
      };

      const regionData = getRegionDataFromChild(itemActive.structureId);

      const formData = {
        ...itemActive,
        structureId: itemActive.structureId,
        region: regionData?.parentId,
      };

      form.setFieldsValue(formData);
      locationsUpdateProcessActive(processActive);
      locationsStructureActive(itemActive.structureId);
      locationsCheckinActive(itemActive.hasCheckin);
      locationsHasAttendanceActive(itemActive.hasAttendance);
      locationsExpirationTimeActive(itemActive.checkinExpirationTime);
      locationsAllowRequestVehicleInboundActionActive(itemActive.allowRequestVehicleInboundAction);
      locationsAllowRequestDockEntryActionActive(itemActive.allowRequestDockEntryAction);
      locationsHasFinishOperationActionActive(itemActive.hasFinishOperationAction);
      locationsReleaseVehicleActionActive(itemActive.allowRequestVehicleEntryAuthorizationAction);
      locationsAllowVehicleArrivalConfirmActionActive(itemActive.allowVehicleArrivalConfirmAction);
      locationsHasReleaseWMSDocumentsActionActive(itemActive.hasReleaseWMSDocuments);
      locationsHasLocationOutOfRangeActive(itemActive.hasLocationOutOfRange);
      locationsHasCheckinScheduleActive(itemActive.hasCheckinSchedule);
      locationsDocumentNumberActive(itemActive.documentType);
      locationsDropHookActive(itemActive.dropHookTypeOfYard);
      locationsHasEntryPermissionActive(itemActive.hasEntryPermission);
      locationsHasRfidReadingActive(itemActive.hasRfidReading);
      locationsPlateFormatActive(itemActive.plateFormatType);
      setChecked(itemActive.active);
    }
  }, [itemActive, processActive, structuresList]);

  const handleOnConfirmCreateUnit = () => {
    const validateUnit = validateCreateUnit({
      originalProcessList,
      processList,
      checkinActive,
      hasAttendanceActive,
      dropHookTypeActive,
      PROCESS_REQUIRED_MESSAGE,
      MESSAGE_ACTIVATE_CHECKIN,
      MANEUVER_PROCESS_REQUIRED_MESSAGE,
    });
    if (validateUnit) {
      onConfirmCreateUnit({
        form,
        message,
        messageDescription: REQUIRED_FIELDS_MESSAGE,
        structureRequiredMessage: STRUCTURE_REQUIRED_MESSAGE,
        checked,
        locationSaveAsync,
        checkedProcess: processList,
        checkedStructureId: structureActive,
        expirationTimeActive,
        checkinActive,
        allowRequestVehicleInboundAction: requestVehicleInboundActionActive,
        allowRequestDockEntryAction: requestDockEntryActionActive,
        hasFinishOperationAction: hasFinishOperationActionActive,
        allowRequestVehicleEntryAuthorizationAction: releaseVehicleActionActive,
        hasAttendanceActive,
        allowVehicleArrivalConfirmAction: vehicleArrivalConfirmActionActive,
        hasReleaseWMSDocuments: hasReleaseWMSDocumentsActive,
        hasLocationOutOfRange: hasLocationOutOfRangeActive,
        hasCheckinSchedule: hasCheckinScheduleActive,
        documentTypeActive,
        dropHookTypeActive,
        hasEntryPermission: hasEntryPermissionActive,
        hasRfidReading: hasRfidReadingActive,
        plateFormatType,
      });
    }
  };

  return (
    <>
      <Layout title={id ? TITLE_PAGE_EDIT : TITLE_PAGE} isLoading={isLoading} role={userData.role}>
        <Form.Provider
          onFormChange={(_, info) => {
            const { changedFields } = info;
            const changedFileldsSize = changedFields?.length || 0;
            if (changedFileldsSize === 1) {
              locationsUpdateFormModified(true);
            }
          }}
        >
          <Spin spinning={isLoadingLocationEdit}>
            <Form style={S.FormLayout} layout={"vertical"} form={form} initialValues={{ layout: formLayout }} onValuesChange={onFormLayoutChange} name="registers">
              <Form.Item label="Id" name="id" hidden>
                <Input />
              </Form.Item>
              <S.LayoutForm>
                <S.FormContainer>
                  <Tabs defaultActiveKey="1">
                    <TabPane tab={`${useTranslation({ id: "data" })}`} key="1" data-testid="tab-data">
                      <DataTabPanel setChecked={setChecked} checked={checked} />
                    </TabPane>
                    <TabPane tab={`${useTranslation({ id: "structure" })}`} key="2" data-testid="tab-data">
                      <StructureTabPane structuresList={structuresList} locationsStructureActive={locationsStructureActive} structureActive={structureActive} form={form} />
                    </TabPane>
                    <TabPane tab={`${useTranslation({ id: "processes_list" })}`} key="3" data-testid="tab-process">
                      <ProcessTabPanel
                        processList={processList}
                        processActive={processActive}
                        updateProcessActive={locationsUpdateProcessActive}
                        locationsConfigurationsProcessShowDrawer={locationsConfigurationsProcessShowDrawer}
                        locationsConfigurationsUpdateConfigurationProcessActive={locationsConfigurationsUpdateConfigurationProcessActive}
                      />
                    </TabPane>
                    <TabPane tab={`${useTranslation({ id: "configuration" })}`} key="4" data-testid="tab-configurations">
                      <ConfigurationTabPane
                        locationsCheckinActive={locationsCheckinActive}
                        locationsExpirationTimeActive={locationsExpirationTimeActive}
                        locationsAllowRequestVehicleInboundActionActive={locationsAllowRequestVehicleInboundActionActive}
                        locationsAllowRequestDockEntryActionActive={locationsAllowRequestDockEntryActionActive}
                        locationsHasFinishOperationActionActive={locationsHasFinishOperationActionActive}
                        locationsReleaseVehicleActionActive={locationsReleaseVehicleActionActive}
                        requestVehicleInboundActionActive={requestVehicleInboundActionActive}
                        requestDockEntryActionActive={requestDockEntryActionActive}
                        expirationTimeActive={expirationTimeActive}
                        checkinActive={checkinActive}
                        hasFinishOperationActionActive={hasFinishOperationActionActive}
                        releaseVehicleActionActive={releaseVehicleActionActive}
                        hasAttendanceActive={hasAttendanceActive}
                        locationsHasAttendanceActive={locationsHasAttendanceActive}
                        locationsAllowVehicleArrivalConfirmActionActive={locationsAllowVehicleArrivalConfirmActionActive}
                        vehicleArrivalConfirmActionActive={vehicleArrivalConfirmActionActive}
                        hasReleaseWMSDocumentsActive={hasReleaseWMSDocumentsActive}
                        locationsHasReleaseWMSDocumentsActionActive={locationsHasReleaseWMSDocumentsActionActive}
                        hasLocationOutOfRangeActive={hasLocationOutOfRangeActive}
                        locationsHasLocationOutOfRangeActive={locationsHasLocationOutOfRangeActive}
                        locationsHasCheckinScheduleActive={locationsHasCheckinScheduleActive}
                        hasCheckinScheduleActive={hasCheckinScheduleActive}
                        locationsConfigurationsShowDrawer={locationsConfigurationsShowDrawer}
                        locationsConfigurationsUpdateConfigurationActive={locationsConfigurationsUpdateConfigurationActive}
                        locationsDocumentNumberActive={locationsDocumentNumberActive}
                        documentTypeActive={documentTypeActive}
                        dropHookActive={dropHookActive}
                        dropHookTypeActive={dropHookTypeActive}
                        locationsDropHookActive={locationsDropHookActive}
                        hasEntryPermissionActive={hasEntryPermissionActive}
                        locationsHasEntryPermissionActive={locationsHasEntryPermissionActive}
                        hasRfidReadingActive={hasRfidReadingActive}
                        locationsHasRfidReadingActive={locationsHasRfidReadingActive}
                        locationsPlateFormatActive={locationsPlateFormatActive}
                        plateFormatType={plateFormatType}
                      />
                    </TabPane>
                  </Tabs>
                </S.FormContainer>
                <Divider />
                <YmsFooterForm
                  showCancelButton={true}
                  confirmbuttontxt={useTranslation({ id: "save" })}
                  cancelbuttontxt={useTranslation({ id: "cancel" })}
                  showConfirmButton={true}
                  onConfirm={handleOnConfirmCreateUnit}
                  customrenderconfirmbutton={<ConfirmButton handleOnConfirm={handleOnConfirmCreateUnit} okText={YES_MESSAGE} cancelText={NO_MESSAGE} title="save_registry" />}
                  customrendercancelbutton={
                    <ConfirmCancelButton
                      handleOnConfirm={handleClose}
                      okText={YES_MESSAGE}
                      cancelText={NO_MESSAGE}
                      formViewOrEditModified={formViewOrEditModified}
                      handleClose={handleClose}
                      messageDescription={id ? DESCRIPTION_CANCEL_EDIT : DESCRIPTION_CANCEL}
                    />
                  }
                />
              </S.LayoutForm>
            </Form>
          </Spin>
        </Form.Provider>
        <DrawerConfiguration
          visibleDrawer={visibleDrawer}
          locationsConfigurationsUpdateConfigurationActive={locationsConfigurationsUpdateConfigurationActive}
          locationsConfigurationsHideDrawer={locationsConfigurationsHideDrawer}
          configurationActive={configurationActive}
          locationsConfigurationsUpdateFormFieldValue={locationsConfigurationsUpdateFormFieldValue}
        />
        <DrawerProcessConfiguration
          visibleDrawer={visibleProcessDrawer}
          locationsConfigurationsUpdateConfigurationProcessActive={locationsConfigurationsUpdateConfigurationProcessActive}
          locationsConfigurationsProcessHideDrawer={locationsConfigurationsProcessHideDrawer}
          configurationActive={configurationProcessActive}
          locationsConfigurationsProcessUpdateFormFieldValue={locationsConfigurationsProcessUpdateFormFieldValue}
        />
      </Layout>
      <button data-testid="form-edit-close" onClick={handleOnConfirmCreateUnit} style={S.FakeBtnConfirm} />
    </>
  );
};

const mapDispatchToActions = (dispatch: any) => bindActionCreators({ ...LocationActions, ...UserSessionActions }, dispatch);

const mapStateToProps = (state) => ({
  isLoading: state.Location.isLoading,
  configurationActive: state.Location.configurationActive,
  configurationProcessActive: state.Location.configurationProcessActive,
  isLoadingLocationEdit: state.Location.isLoadingLocationEdit,
  formViewOrEditModified: state.Location.formViewOrEditModified,
  createActive: state.Location.createActive,
  userData: state.UserSession.userData,
  processList: state.Location.processList,
  itemActive: state.Location.itemActive,
  processActive: state.Location.processActive,
  structuresList: state.Location.structuresList,
  structureActive: state.Location.structureActive,
  hasAttendanceActive: state.Location.hasAttendanceActive,
  expirationTimeActive: state.Location.expirationTimeActive,
  checkinActive: state.Location.checkinActive,
  requestVehicleInboundActionActive: state.Location.requestVehicleInboundActionActive,
  requestDockEntryActionActive: state.Location.requestDockEntryActionActive,
  hasFinishOperationActionActive: state.Location.hasFinishOperationActionActive,
  releaseVehicleActionActive: state.Location.releaseVehicleActionActive,
  vehicleArrivalConfirmActionActive: state.Location.vehicleArrivalConfirmActionActive,
  hasReleaseWMSDocumentsActive: state.Location.hasReleaseWMSDocumentsActive,
  hasLocationOutOfRangeActive: state.Location.hasLocationOutOfRangeActive,
  hasCheckinScheduleActive: state.Location.hasCheckinScheduleActive,
  visibleDrawer: state.Location.visibleDrawer,
  visibleProcessDrawer: state.Location.visibleProcessDrawer,
  originalProcessList: state.Location.originalProcessList,
  documentTypeActive: state.Location.documentTypeActive,
  dropHookActive: state.Location.dropHookActive,
  dropHookTypeActive: state.Location.dropHookTypeActive,
  hasEntryPermissionActive: state.Location.hasEntryPermissionActive,
  hasRfidReadingActive: state.Location.hasRfidReadingActive,
  plateFormatType: state.Location.plateFormatType,
});

export default connect(mapStateToProps, mapDispatchToActions)(LocationForm);
